export default {
  title: '产品物料数据',
  description: '管理产品主数据、物料信息及 BOM 关系（数据来源于 MDM 系统）',
  sync: {
    title: '数据同步状态',
    normal: '同步正常',
    syncing: '同步中',
    error: '同步异常',
    lastSyncTime: '最后同步时间：{time}',
    productCount: '产品记录：{count} 条',
    materialCount: '物料记录：{count} 条'
  },
  tabs: {
    product: '产品数据',
    material: '物料数据'
  },
  filter: {
    productTitle: '产品数据筛选',
    materialTitle: '物料数据筛选',
    scheme: '方案:',
    defaultScheme: '默认方案',
    recentScheme: '最近使用',
    search: '搜索',
    reset: '重置',
    conditions: '增减条件',
    save: '保存',
    expand: '展开',
    collapse: '收起',
    contains: '包含',
    equals: '等于',
    productConditionTitle: '增减产品筛选条件',
    materialConditionTitle: '增减物料筛选条件'
  },
  actions: {
    detail: '详情',
    attrDetail: '属性详情',
    bomQuery: 'BOM查询',
    query: '查询',
    recordsCount: '共 {count} 条记录'
  },
  status: {
    active: '有效',
    inactive: '无效',
    latest: '最新',
    history: '历史'
  },
  fields: {
    productCode: '产品编码',
    productName: '产品名称',
    prodLine: '产品线',
    brandName: '品牌',
    prodCategoryName: '类别',
    prodTypeName: '类型',
    prodModel: '型号',
    color: '颜色',
    weight: '重量(kg)',
    validFrom: '生效日期',
    validTo: '失效日期',
    status: '状态',
    itemCode: '物料编码',
    itemName: '物料名称',
    itemType: '物料类型',
    unit: '单位',
    materialGroup: '物料组',
    baseUnit: '基本单位',
    materialStatus: '物料状态',
    operation: '操作',
    parentItemCode: '父物料编码',
    parentItemName: '父物料名称',
    childItemCode: '子物料编码',
    childItemName: '子物料名称',
    bomQty: '用量',
    bomUnit: '单位',
    bomLevel: '层级',
    parentVersion: '父件版本',
    childVersion: '子件版本',
    isLatest: '是否最新'
  },
  detailFields: {
    categoryName: '品类',
    brandName: '品牌',
    productName: '产品名称',
    productModel: '机型',
    bareCode: '裸机号',
    upcCode: 'UPC',
    eanCode: 'EAN',
    productColor: '颜色',
    singlePackageLength: '单个包装长度',
    headsetBatteryWeightG: '耳机电池重量/g',
    certificationTransportReport: '整机认证+运输报告',
    caseBatteryWeightG: '电池盒电池重量/g',
    wirelessTransmissionType: '无线传输类型',
    bluetoothName: '蓝牙名',
    productWeightG: '产品重量/g',
    batteryLifeH: '续航时间/h',
    chargingTimeMin: '充电时间/min',
    chargingVoltage: '充电电压',
    chargingMethod: '充电方式',
    standbyTime: '待机时间',
    dustWaterproofLevel: '防尘防水等级',
    bluetoothChip: '蓝牙芯片',
    bluetoothVersion: '蓝牙版本',
    bluetoothFrequencyRange: '蓝牙工作频率范围',
    bluetoothCodecFormat: '蓝牙编解码格式',
    bluetoothConnectionDistance: '蓝牙连接距离',
    maxRfOutputPower: '最大射频输出功率',
    productSize: '产品尺寸',
    eqType: 'EQ种类',
    earphoneCoreTech: '耳机芯技术',
    micTech: 'MIC技术',
    speakerImpedance: '喇叭阻抗',
    manufacturingRegion: '制造地区',
    warrantyPeriod: '质保时间',
    material: '材质',
    function: '功能',
    speakerType: '扬声器类型',
    frequencyResponse: '频率响应',
    speakerSensitivity: '扬声器灵敏度',
    microphoneSensitivity: '麦克风灵敏度',
    compatibleProfiles: '兼容配置文件',
    frequencyBand: '频带',
    fastCharging: '快速充电',
    supportedAudioCodecs: '支持的音频编解码器',
    singlePackageWidth: '单个包装宽度',
    singlePackageHeight: '单个包装高度',
    singlePackageVolume: '单个包装体积',
    singlePackageNetWeight: '单个包装净重',
    singlePackageGrossWeight: '单个包装毛重',
    outerBoxLength: '外箱长度',
    outerBoxWidth: '外箱宽度',
    outerBoxHeight: '外箱高度',
    outerBoxVolume: '外箱体积',
    outerBoxNetWeight: '外箱净重',
    outerBoxGrossWeight: '外箱毛重',
    innerBoxQuantity: '内箱数量',
    innerBoxSize: '内箱尺寸',
    packagingMaterial: '包装材质',
    chargingCableType: '充电线类型',
    chargingCableLength: '充电线长度',
    chargingCableMaterial: '充电线材质',
    packingList: '包装清单',
    caseBatteryVolumeCm3: '电池盒电池体积/cm³',
    headsetBatteryCapacityWhMah: '耳机电池容量/Wh-mAh',
    headsetLithiumContentMg: '耳机锂含量/mg',
    headsetBatteryVolumeCm3: '耳机电池体积/cm³',
    headsetBatteryType: '耳机电池类型',
    headsetBatterySize: '耳机电池尺寸',
    headsetBatteryQuantity: '耳机电池数量',
    headsetMaxCycleCount: '耳机最大循环次数',
    caseLithiumContentMg: '电池盒锂含量/mg',
    caseBatteryType: '电池盒电池类型',
    caseBatterySize: '电池盒电池尺寸',
    caseBatteryQuantity: '电池盒电池数量',
    caseMaxCycleCount: '电池盒最大循环次数',
    caseBatteryCapacityWhMah: '电池盒电池容量/Wh-mAh',
    batteryCertificationTransportReport: '电池认证+运输报告',
    waterproofTestCondition: '防水等级测试条件',
    batteryLifeTestCondition: '电池续航测试条件',
    fastChargeTest: '快充测试',
    materialName: '物料名称',
    productType: '产品类型',
    shortName: '简称',
    mainUnit: '主单位',
    bigCategory: '大类',
    specifications: '规格',
    createdDate: '创建日期',
    upDownPassage: '上下通道',
    version: '版本号',
    firstCategory: '一级分类',
    secondCategory: '二级分类',
    thirdCategory: '三级分类',
    fourthCategory: '四级分类',
    managementCategory: '管理品类',
    customsNo: '海关编号',
    customsDeclarationName: '报关品名',
    englishName: '英文名称',
    chineseCustomsNo: '中文海关编号',
    declarationBrand: '品牌(报关)',
    customsModel: '海关型号',
    areaOrigin: '区域/原产地',
    netWeight: '净重',
    originArea: '原产地',
    specialAttributes: '货品特殊属性',
    euUkHsCode: '欧英HS编码',
    jpnHsCode: '日本HS编码',
    caHsCode: '加拿大HS编码',
    usHtsCode: '美国HTS编码',
    krHsCode: '韩国HS编码',
    htsCode: '通用HS编码',
    logisticsBrand: '品牌(物流)',
    majorCategoryDropdown: '大类下拉',
    newErpCategory: '新ERP大类',
    boxLong: '外箱长',
    boxWidth: '外箱宽',
    boxHeight: '外箱高',
    boxWeight: '外箱重',
    boxGauge: '外箱规格',
    barCode: 'UPC条码',
    warehouseBrand: '品牌',
    brandNameText: '品牌名称'
  },
  placeholder: {
    productCode: '请输入产品编码',
    productName: '请输入产品名称',
    prodLine: '请选择产品线',
    brandName: '请输入品牌',
    prodCategoryName: '请输入类别',
    prodTypeName: '请输入类型',
    prodModel: '请输入型号',
    color: '请输入颜色',
    weight: '请输入重量',
    validFrom: '请输入生效日期',
    validTo: '请输入失效日期',
    status: '请选择状态',
    itemCode: '请输入物料编码',
    itemName: '请输入物料名称',
    itemType: '请选择物料类型',
    unit: '请输入单位',
    materialGroup: '请输入物料组',
    baseUnit: '请输入基本单位',
    materialStatus: '请输入物料状态',
    parentItemCode: '请输入父物料编码',
    childItemCode: '请输入子物料编码'
  },
  modal: {
    productDetail: '产品详情',
    materialDetail: '物料属性详情',
    bomTitle: 'BOM结构查询',
    noBomData: '暂无BOM数据',
    levelTitle: 'L{level} 层级',
    levelCount: '共 {count} 条',
    productInfo: '产品信息',
    productDetailInfo: '产品明细',
    materialBasic: '基础属性',
    materialCategory: '分类属性',
    materialLogistics: '物流属性',
    materialWarehouse: '仓库属性'
  },
  options: {
    openrun: 'OpenRun系列',
    openmove: 'OpenMove系列',
    opencomm: 'OpenComm系列',
    other: '其他',
    raw: '原材料',
    semi: '半成品',
    finished: '成品',
    packaging: '包装材料'
  }
}
